import moment from 'moment';
import { ContentControlItem } from '../item/content-control-item';
import { ContentControlledItemsSpecifications } from '../specifications/content-controlled-items-specifications';
import { ScheduleAiJobsRequest } from '../ai/schedule-ai-jobs-request';
import { ScheduleAiJobResponse } from '../ai/schedule-ai-job-response';
import { CensorshipReportEntry } from '../reporting/censorship-report-entry';

export abstract class IContentControlRepository {
  abstract create(mediaId: number): Promise<ContentControlItem>;
  abstract scheduleAiJob(
    request: ScheduleAiJobsRequest,
  ): Promise<ScheduleAiJobResponse[]>;
  abstract searchItems(
    specification: ContentControlledItemsSpecifications,
  ): Promise<Array<ContentControlItem>>;
  abstract getCensorshipAiReport(
    mediaUniqueIdPattern: string,
    from: moment.Moment,
    to: moment.Moment,
  ): Promise<CensorshipReportEntry[]>;
  abstract getItemByMediaId(
    mediaId: number,
    includeThumbnails: boolean,
  ): Promise<ContentControlItem>;
  abstract getItemByChannelUid(channelUid: string): Promise<ContentControlItem>;
  abstract save(item: ContentControlItem): Promise<boolean>;
  abstract saveLive(item: ContentControlItem): Promise<boolean>;
  abstract associateTranscodingJob(
    contentControlItemUid: string,
    transcodingJobUid: string,
  ): Promise<boolean>;
  abstract loadSubtitle(url: string): Promise<string>;
}
